import React from 'react';
import LinkTo from '../../../../../shared/LinkTo/LinkTo';
import SocialIcon from '../../../../../shared/SocialIcon';
import { SocialIconType, SocialNetworkLink } from '../../../../../../types';
import cn from 'classnames';

import './PalmMagazineFooterSocialList.scss';

export interface SocialListProps {
  socialLinks: SocialNetworkLink[];
  footerVariant: 'Palm' | 'AvIcnExpo';
}

export function PalmMagazineFooterSocialList(props: SocialListProps) {
  const { socialLinks, footerVariant } = props;
  const socialClassName = cn('c-palm-magazine-footer-social', {
    'c-palm-magazine-footer-av-icn-expo-social': footerVariant === 'AvIcnExpo',
  });
  return (
    <div className={socialClassName}>
      <ul className="c-palm-magazine-footer-social__list">
        {socialLinks.map((social) => {
          return (
            <li
              key={social.type}
              className="c-palm-magazine-footer-social__list-item"
            >
              <LinkTo
                to={social.url}
                target="_blank"
                className="c-palm-magazine-footer-social__link"
              >
                <SocialIcon
                  data-testid={`social-icon-${social.type}`}
                  type={social.type as SocialIconType}
                  className="c-palm-magazine-footer-social__icon"
                />
              </LinkTo>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default PalmMagazineFooterSocialList;
